/// <amd-module name="Build/Common/Commands/queuebuild/Command.types" />
import { Build, DefinitionReference, BuildDefinitionVariable, BuildRepository, AgentPoolQueue } from "Build/Client/Contracts/Build";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IQueueBuildProps extends IVssComponentProperties {
    pageContext: IVssPageContext;
    project: string;
    definition: DefinitionReference;
    repository: BuildRepository;
    processType: number | null;
    source: string;
    onSuccess(build: Build): void;
    onDismiss(): void;
    defaultSourceBranch?: string;
    queue?: AgentPoolQueue;
    definitionVariables?: { [key: string]: BuildDefinitionVariable };
    previousRunVariables?: { [key: string]: string };
    previousTemplateParameters?: { [key: string]: string };
}
